import api from "../proxy/config";
import axios from "./axiosConfig";

const getHeaders = () => ({
    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const handleBackendError = (error, defaultMsg) => {
    if (error.response?.status === 500 || (typeof error.response?.data === 'string' && error.response.data.includes("Internal Server Error"))) {
        throw new Error("Si è verificato un problema, riprova più tardi.");
    }
    const backendError = error.response?.data;
    const message = typeof backendError === 'string'
        ? backendError
        : (backendError?.message || backendError?.error || defaultMsg);
    throw new Error(message);
};

export const getStripeSettings = async () => {
    try {
        const response = await axios.get(api.getStripeSettings, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel recupero delle impostazioni Stripe");
    }
};

export const updateStripeSettings = async (settings) => {
    try {
        const response = await axios.post(api.updateStripeSettings, settings, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante l'aggiornamento delle impostazioni Stripe");
    }
};
 